import VerticalSlot from '@ulta/core/components/VerticalSlot/VerticalSlot';

export default VerticalSlot;